// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","mobile-threshold-width":"760px","inputContainer":"LoginForm_inputContainer__2VBP5","formContainer":"LoginForm_formContainer__Rq3MI"};